"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EditableWidthButton = exports.LABELS = void 0;
const tslib_1 = require("tslib");
const React = tslib_1.__importStar(require("react"));
const nano_theme_1 = require("nano-theme");
const Ripple_1 = require("@jsonjoy.com/ui/lib/misc/Ripple");
const context_1 = require("@jsonjoy.com/ui/lib/styles/context");
exports.LABELS = {
    narrow: 'Narrow',
    mid: 'Mid',
    wide: 'Wide',
};
const EDITABLE_WIDTH_VISUAL_RATIOS = {
    narrow: 0.4,
    mid: 0.65,
    wide: 0.95,
};
const widthBtnClass = (0, nano_theme_1.drule)({
    d: 'inline-flex',
    fld: 'column',
    jc: 'space-around',
    ai: 'center',
    bdrad: '10px',
    cur: 'default',
    out: 0,
    bd: 0,
    bxz: 'border-box',
    us: 'none',
    minW: 0,
});
const widthBtnFrameClass = (0, nano_theme_1.rule)({
    pos: 'relative',
    d: 'flex',
    fld: 'column',
    jc: 'center',
    ai: 'center',
    bdrad: '2px',
    bxz: 'border-box',
});
const widthBtnBarClass = (0, nano_theme_1.rule)({
    bdrad: '1.5px',
});
const widthBtnLabelClass = (0, nano_theme_1.rule)({
    fz: '.65em',
    pdt: '.35em',
});
const EditableWidthButton = ({ kind, size, active, onClick }) => {
    const theme = (0, nano_theme_1.useTheme)();
    const styles = (0, context_1.useStyles)();
    const stretch = size === undefined;
    const renderSize = size ?? 64;
    const ratio = EDITABLE_WIDTH_VISUAL_RATIOS[kind];
    const activeBg = styles.col.accent(0, 'bg-2');
    const className = widthBtnClass({
        w: stretch ? '100%' : renderSize + 'px',
        h: renderSize + 'px',
        flex: stretch ? '1 1 0' : void 0,
        bg: active ? activeBg : theme.g(0, 0.01),
        '&:hover': { bg: active ? activeBg : theme.g(0, 0.04) },
    });
    const frameSize = Math.round(renderSize * (stretch ? 0.78 : 0.7));
    const framePadding = Math.max(2, Math.round(frameSize * 0.06));
    const frameInner = frameSize - 2 * framePadding;
    const barColor = active ? theme.color.sem.accent[0] : theme.g(0, 0.55);
    const frameBorder = active ? theme.color.sem.accent[0] : theme.g(0, 0.18);
    const barHeight = Math.max(2, Math.round(frameSize * 0.07));
    const barGap = Math.max(1, Math.round(frameSize * 0.06));
    const barFull = Math.round(frameInner * ratio);
    const barShort = Math.max(barHeight * 2, Math.round(barFull * 0.6));
    const barStyle = (w) => ({
        width: w + 'px',
        height: barHeight + 'px',
        background: barColor,
        marginBottom: barGap + 'px',
    });
    const lastBarStyle = {
        ...barStyle(barShort),
        marginBottom: 0,
    };
    return (React.createElement(Ripple_1.Ripple, { ms: 1000 },
        React.createElement("button", { type: "button", className: className, onClick: onClick },
            React.createElement("span", { className: widthBtnFrameClass, style: {
                    width: frameSize + 'px',
                    height: Math.round(frameSize * 0.85) + 'px',
                    border: '1px dashed ' + frameBorder,
                    padding: framePadding + 'px',
                    marginTop: 8,
                } },
                React.createElement("span", { style: {
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'flex-start',
                        width: barFull + 'px',
                    } },
                    React.createElement("span", { className: widthBtnBarClass, style: barStyle(barFull) }),
                    React.createElement("span", { className: widthBtnBarClass, style: barStyle(barFull) }),
                    React.createElement("span", { className: widthBtnBarClass, style: lastBarStyle }))),
            renderSize > 32 && (React.createElement("span", { className: widthBtnLabelClass, style: { color: active ? theme.color.sem.accent[0] : theme.g(0, 0.7) } }, exports.LABELS[kind])))));
};
exports.EditableWidthButton = EditableWidthButton;
